import React from "react";

/** A label/value row in the site page's definition-list panels (site details, fob summary). */
export default function SiteDetailItem({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="grid grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] gap-4 px-4 py-3">
      <dt className="text-xs font-semibold tracking-wide uppercase text-slate-500">
        {label}
      </dt>
      <dd className="min-w-0 text-sm font-medium wrap-break-word text-slate-800">
        {children}
      </dd>
    </div>
  );
}
